import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import axios from "axios";
import DatePicker from "react-datepicker";
import { useAuth0 } from "@auth0/auth0-react";
//import JSONPretty from 'react-json-pretty';
import { Button } from 'react-bootstrap';
import { IoIosLink } from 'react-icons/io'; 
import JSONPretty from 'react-json-pretty';

const funzione_esterna = require('../Funzioni_comuni_esterne')
// IoIosLink


const Nuovo_Progetto = (props) => {
//    const [somma, calcola_somma] = useState('');
    const [input, setInput] = useState({
        id_alunno: '',
        id_ditta: '',
        nome_alunno: '',
        nome_ditta: '',

        data_inizio: '',
        data_fine: '',
        mattina: true,
        pomeriggio: true
    });
    const [lista_ditte, SET_lista_ditte] = useState([]);
    const [lista_alunni, SET_lista_alunni] = useState([]);
    const { user, isAuthenticated } = useAuth0();

    


    function handleChange(event) {
        event.preventDefault()
        let { name, value } = event.target;
        console.log('entrato')
        console.log(name)
        console.log(value)

        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
        // se si stanno cambiando i campi ditta e alunno bisogna cercare in mongo gli alunni inseriti
        if (event.target.name === 'ragione_sociale_ditta') {
            console.log('ditta1')
            Carica_ditta(event.target.value)
        }
        if (event.target.name === 'cognome_alunno') {
            console.log('nome_alunno')
            Carica_alunno(event.target.value)
        }

    }

    function handleClick_pulsante(event) {
        event.preventDefault();
        console.log('data')
        console.log(props.start_Date)
      
        var date_1 = new Date(props.start_Date);
        var date_2 = new Date(props.end_Date);

        let data_start = new Date(date_1.getFullYear(), date_1.getMonth(), date_1.getDate(), 6, 1, 0)
        let data_end = new Date(date_2.getFullYear(), date_2.getMonth(), date_2.getDate(), 23, 1, 0)

        console.log(data_start)
      
        const nuovo_progetto = {
            id_alunno: input.id_alunno,
            id_classe: props.classe_selezionata,
            classe_nome_attuale: input.classe_nome,
            classe_nome_corso_attuale: input.classe_corso,
            id_ditta: input.id_ditta,
            data_inizio: data_start,
            data_fine: data_end,
            mattina: input.mattina,
            pomeriggio: input.pomeriggio
        }
        console.log(input);


        let lista_aux_progetti = props.lista_progetti
        lista_aux_progetti.unshift(nuovo_progetto) 
        console.log(lista_aux_progetti);
        funzione_esterna.Aggiorna_lista_alunni_per_semaforo_esterno(props.lista_alunni, lista_aux_progetti)

        axios.post('/progetti/salva_nuovo_progetto', nuovo_progetto)
        .then((res) => {
            setInput(prevInput => {
                return {
                    ...prevInput,
                    ragione_sociale_ditta:  '',
                    cognome_alunno: '',
                    nome_alunno: '',
                    id_alunno: '',
                    id_ditta: '' 
                }
            })
            //                console.log('Aggiunta una classe')
            props.SET_variab_aggiorna(current => !current)
         }).catch((error) => {
            console.log('errore')
            alert("Errore nel caricamento")
        });
        console.log('+++++++++++++++++++++++');

        console.log(props.lista_progetti);

    }


    function handle_checkbox(event) {
        const { name, checked } = event.target;
        console.log('handle_change' + name + ' - ' + checked)
        console.log(event.target.name)
        console.log(event.target.value)
        console.log(event.target.checked)

        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: checked
            }
        })
    }


    const Carica_ditta = (sottostringa) => {
        //    funzione_set_aggiornamento(true)
        let end_date = 5
        var utente = 'utente_unico'
        //        https://mydomain.dm/fruit/{"name":"My fruit name", "color":"The color of the fruit"}
        axios.get('/ditte/ricerca_ditte/' + utente + '/' + sottostringa + '/' + user.email)
            .then((res) => {
                console.log('domande appena fecciate da mongo')
                console.log(res.data)
                SET_lista_ditte(res.data)
                let trovato_id = res.data.find(x => x.ragione_sociale === sottostringa)._id;
                console.log('id_ditta')
                console.log(trovato_id)
                setInput(prevInput => {
                    return {
                        ...prevInput,
                        ['id_ditta']: trovato_id
                    }
                })
            }).catch((error) => {
                console.log(error)
            });
    }

    const Carica_alunno = (sottostringa) => {
        var utente = 'utente_unico'
        axios.get('/progetti/progetti_ricerca_alunno/' + utente + '/'  + props.classe_selezionata + '/'  + sottostringa + '/' + user.email)
            .then((res) => {
//                console.log('domande appena fecciate da mongo')
//                console.log(res.data)
                SET_lista_alunni(res.data)
//                console.log(res.data)
                     let item = res.data.find(x => x.cognome === sottostringa);
                //                console.log('id_alunno')
                //                console.log(trovato_id)
                console.log (item)
                if (item != undefined) {
                    setInput(prevInput => {
                        return {
                            ...prevInput,
                            ['id_alunno']: item._id,
                            ['nome_alunno']: item.nome,
                  
                            ['classe_nome']: item.classe_id.nome,
                            ['classe_corso']: item.classe_id.corso
                        }
                    })
                }
            }).catch((error) => {
                console.log(error)
            });
    }


    const set_Start_Date_cambia = (date) => {
        console.log(date)     
        console.log(props.tutor)      
     
        props.set_Start_Date(date)
        setInput(prevInput => {
            return {
                ...prevInput,
                'data_iniziale_solo_prova': date
            }
            })
        axios.patch('/tutor/cambia_data/' + props.tutor._id + '/start/' + date)
        .then((res) => {
            console.log(res.data)
        }).catch((error) => {
            console.log(error)
        });
    } 

    const set_End_Date_cambia = (date) => {
      console.log(date)     
      console.log(props.tutor)      
   
      props.set_End_Date(date)
      setInput(prevInput => {
        return {
            ...prevInput,
            'data_finale_solo_prova': date
        }
        })
      axios.patch('/tutor/cambia_data/' + props.tutor._id + '/end/' + date)
      .then((res) => {
          console.log(res.data)
      }).catch((error) => {
          console.log(error)
      });
    } 

    return (
        
        <>
        
		

        {/* <JSONPretty data={input} /> */}
        {(props.account_dati.utente_debug) &&
        
            <JSONPretty data={input} />
        }
        
        {props.tutor != '' &&
        <>
            <h4>Nuovo Progetto</h4>
            <form>
                <div className='form-group'>
                    <label>Ricerca alunno</label>
                    <input type="text" list="data_alunni" onChange={handleChange} name="cognome_alunno" value={input.cognome_alunno} autoComplete="off" className="form-control" />
                    <datalist id="data_alunni">
                        {lista_alunni.map((item, key) =>
                            <option key={key} value={item.cognome}>{item.cognome} &emsp; {item.nome}  </option>
                        )}
                    </datalist>
                    <p></p>
                    <label>Ricerca ditta</label>
                    <input type="text" list="data_ditte" onChange={handleChange} name="ragione_sociale_ditta" value={input.ragione_sociale_ditta} autoComplete="off" className="form-control"></input>

                    <datalist id="data_ditte">
                        {lista_ditte.map((item, key) =>
                            <option key={key} value={item.ragione_sociale} >{item.ragione_sociale} </option>
                        )}
                    </datalist>
                </div>
                <p></p>
                <h4> {input.cognome_alunno} &emsp;  {input.nome_alunno}  &emsp; 
                {input.cognome_alunno != undefined && input.ragione_sociale_ditta != undefined && <IoIosLink color='black' />} &emsp; {input.ragione_sociale_ditta}
                 </h4>   

                <div className='form-group d-flex flex-row '>
                    <input type="checkbox" name="mattina" checked={input.mattina} onChange={handle_checkbox}></input>
                    <label class="form-check-label" for="exampleCheck1">Mattine</label> &emsp; 
                    <input type="checkbox" name="pomeriggio" checked={input.pomeriggio} onChange={handle_checkbox}></input>
                    <label class="form-check-label" for="exampleCheck1">Pomeriggi</label>
                </div>

                <div className='form-group d-flex flex-row '>
                    <div className='d-flex flex-column '>

                        <label class="form-check-label" for="exampleCheck1">Data di inizio stage</label>
                        <DatePicker selected={props.start_Date} dateFormat="dd/MM/yyyy" data-value="apply clicked" onChange={(date) => set_Start_Date_cambia(date)} />
                    </div>
                    &emsp; 
                    <div className='d-flex flex-column '>

                        <label class="form-check-label" for="exampleCheck1">Data di fine stage</label>
                        <DatePicker selected={props.end_Date} dateFormat="dd/MM/yyyy" onChange={(date) => set_End_Date_cambia(date)} />
                    </div>

                </div>
                <div className= 'd-flex flex-row-reverse'>
                    <Button onClick={handleClick_pulsante} disabled={!(input.cognome_alunno != undefined && input.ragione_sociale_ditta != undefined )} className="">Salva Progetto</Button>
                </div>
                 <h1></h1>
            </form>
            </>
        }
                	
        </>
    )
}
export default Nuovo_Progetto;